export default "__VITE_ASSET__CPJo4pf2__"